/**
 * 本地存储实现,封装localStorage和sessionStorage
 */
class LoacalStore {
  disabled = !!window?.localStorage
  set(key: string, val: any) {
    if (this.disabled) {
      return
    }
    if (val === undefined) {
      return this.remove(key)
    }
    localStorage.setItem(key, JSON.stringify(val))
    return val
  }

  get(key: string, def?: any) {
    if (this.disabled) {
      return def
    }
    const v = localStorage.getItem(key)
    if(v) {
      const val = deserialize(v)
      return (val === undefined ? def : val)
    }
    return def
  }

  has(key: string) {
    return this.get(key) !== undefined
  }

  remove(key: string) {
    if (this.disabled) {
      return
    }
    localStorage.removeItem(key)
  }

  clear() {
    if (this.disabled) {
      return
    }
    localStorage.clear()
  }
}

const store = new LoacalStore()

window.addEventListener('beforeunload', () => {
  store.clear()
})

function deserialize(val: string) {
  if (typeof val !== 'string') {
    return undefined
  }
  try {
    return JSON.parse(val)
  } catch (e) {
    return val || undefined
  }
}

export default store
